// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* translation row */
.TranslationRow_translation_row_root__xNqn0 {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
}

.TranslationRow_translation_row_root__xNqn0:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 1px solid var(--color-bg-caselist-item-hover);
}

.TranslationRow_translation_row_root_selected__Elao8 {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;
  background-color: var(--color-bg-caselist-item-selected);
  border: 1px solid var(--color-bg-caselist-item-selected);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);

}

.TranslationRow_translation_row_root__xNqn0 b {
  padding: 0px 15px 0px 10px;
}

.TranslationRow_translation_row_root_selected__Elao8 b {
  padding: 0px 15px 0px 10px;
}

.TranslationRow_short_language__3mYRu {
  width: 15%;
}

.TranslationRow_long_language__\\+HOWX {
  width: 60%;
  overflow: scroll;
}

.TranslationRow_active_translation__rjKY9 {
  width: 10%;
  padding: 0px 5px;
}

.TranslationRow_default_translation__rpElA {
  width: 10%;
  padding: 0px 5px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/TranslationRow/TranslationRow.module.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wDAAwD;EACxD,wDAAwD;EACxD,gDAAgD;;AAElD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* translation row */\n.translation_row_root {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.translation_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 1px solid var(--color-bg-caselist-item-hover);\n}\n\n.translation_row_root_selected {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n  background-color: var(--color-bg-caselist-item-selected);\n  border: 1px solid var(--color-bg-caselist-item-selected);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n\n}\n\n.translation_row_root b {\n  padding: 0px 15px 0px 10px;\n}\n\n.translation_row_root_selected b {\n  padding: 0px 15px 0px 10px;\n}\n\n.short_language {\n  width: 15%;\n}\n\n.long_language {\n  width: 60%;\n  overflow: scroll;\n}\n\n.active_translation {\n  width: 10%;\n  padding: 0px 5px;\n}\n\n.default_translation {\n  width: 10%;\n  padding: 0px 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"translation_row_root": `TranslationRow_translation_row_root__xNqn0`,
	"translation_row_root_selected": `TranslationRow_translation_row_root_selected__Elao8`,
	"short_language": `TranslationRow_short_language__3mYRu`,
	"long_language": `TranslationRow_long_language__+HOWX`,
	"active_translation": `TranslationRow_active_translation__rjKY9`,
	"default_translation": `TranslationRow_default_translation__rpElA`
};
export default ___CSS_LOADER_EXPORT___;
